export const locale = {
  lang: "hi",
  data: {
    LABELS: {
      others: {
        updateRequired: "अपडेट आवश्यक",
        updateAppMessage: "ऐप का नया संस्करण उपलब्ध है, कृपया एक्सेस करने के लिए अपडेट करें।",
        noCustomerFound: "कोई ग्राहक नहीं मिला",
        kirloSmart: "किर्लोस्मार्ट",
        subTitle: "पंप स्वास्थ्य, डिजिटली सरलीकृत",
        justNow: "अभी",
        viewDetails: "विवरण देखें",
        retry: "पुन: प्रयास करें",
        live: "लाइव",
        offline: "ऑफ़लाइन",
        monthInitial: "म",
        noCancel: "नहीं, रद्द करें",
        yesMute: "हां, म्यूट करें",
        no: "नहीं",
        yes: "हांं",
        liveStreaming: "लाइव स्ट्रीमिंग",
        filters: "फ़िल्टर",
        problem: "समस्या",
        cause: "कारण",
        attachments: "अनुलग्नक",
        inComingSoonMsg: "हम इसे बढ़ाने और चलाने के लिए कड़ी मेहनत कर रहे हैं।",
        availableSoon: "यह जल्द ही उपलब्ध होगा!",
        selected: "गिने चुने",
        period7D: "7 द",
        period1M: "1 म",
        period6M: "6 म",
        period1Y: "1 य",
        selectAll: "सभी का चयन करे",
        noMatching: "मिलान नहीं",
        found: "मिला",
        inactive: "निष्क्रिय",
        PumpsandSystems: "पंप और प्रणाली",
        PumpMasters: "पंप मास्टर्स",
        SystemMasters: "प्रणाली मास्टर्स",
        download: "डाउनलोड",
      },

      dashboard: {
        overdue: "अतिदेय",
        dueIn2Months: "2 महीने में देय",
        replacementDueOn: "रिप्लेसमेंट ड्यू ऑन",
        adsNotAvailable: "विज्ञापन उपलब्ध नहीं है",
        overview: "अवलोकन",
        All: "कुल पंप",
        NeedAttentionRunning: "ध्यान देने की जरूरत है - दौड़ना",
        NeedAttentionIdle: "ध्यान देने की जरूरत है - निष्क्रिय",
        HealthyRunning: "स्वस्थ - दौड़ना",
        HealthyIdle: "स्वस्थ - निष्क्रिय",
        DeviceDisconnected: "डिवाइस डिस्कनेक्ट किया गया",
        search: "शोध",
        footerImage: "hindi",
        AllSites: "सभी साइटें",
        SiteAnalytics: "साइट विश्लेषिक",
        Last7Days: "(आखिरी 7 दिन)",
        customerDrawer: {
          sortBy: "क्रमबद्ध करें",
          zone: "क्षेत्र",
        },
        noPumpAvailable: {
          needAttentionRunning: "ऐसा लगता है कि यहां कोई 'ध्यान देने की जरूरत है - दौड़ना' पंप नहीं हैं।",
          needAttentionIdle: "ऐसा लगता है कि यहां कोई 'ध्यान देने की जरूरत - निष्क्रिय' पम्प नहीं है।",
          deviceDisconnected: "ऐसा लगता है कि कोई 'डिवाइस डिस्कनेक्टेड' पंप नहीं है।",
          healthyRunning: "ऐसा लगता है कि यहां कोई 'स्वस्थ-चलित' पंप नहीं है।",
          healthyIdle: "ऐसा लगता है कि कोई 'स्वस्थ-निष्क्रिय' पंप नहीं है।",
        },
        sparesDemand: "स्पेयर्स डिमांड",
        country: "देश",
        zones: "ज़ोन",
        pumpModels: "पंप मॉडल",
        pumpType: "पंप प्रकार",
        Customers: "ग्राहक",
        customers: "ग्राहक",
        Sites: "साइटें",
        sites: "साइटें",
        masters: "मास्टर्स",
        high: "उच्च",
        low: "कम",
        Alerts: "अलर्ट",
        Alarms: "अलार्म",
        pumpAndSystemTypes: "पंप & प्रणाली प्रकार",
        pumpAndSystemModels: "पंप & प्रणाली मॉडल",
        topCauses: "शीर्ष कारण",
      },
      user: {
        all:"सब",
        active: "सक्रिय",
        deactive: "निष्क्रिय",
        status: "स्थिती",
      },
      pump: {
        Energy: "ऊर्जा की बचत",
        kirloSmart: "KirloSmart",
        healthyValue: "स्वस्थ",
        digitalParameters: "डिजिटल पैरामीटर्स",
        alarmingValue: "ट्रिपिंग ",
        healthyText: "स्वस्थ पाठ",
        alarmingText: "खतरनाक पाठ",
        subTitle: "Pump Health, Digitally Simplified",
        pump: "पंप",
        system: "प्रणाली",
        innerPump: "भीतरी पंप",
        Pump: "पंप",
        PumpMaster: "पंप मास्टर",
        SystemMaster: "प्रणाली मास्टर",
        System: "प्रणाली",
        active: "सक्रिय",
        deactivated: "निष्क्रिय",
        updatedAt: "पर अपडेट किया गया",
        maintenance: "देखभाल",
        switchOnPump: "पंप शुरू करें",
        switchOffPump: "पंप बंद करें",
        contactDetails: "संपर्क तपशील",
        engineDetails: "इंजन तपशील",
        gearBoxDetails: "गियर बॉक्स तपशील",
        motorDetails: "मोटर तपशील",
        lastServiced: "अंतिम सर्विंग",
        nextServicing: "अगला सर्विसिंग",
        mttr: "एमटीटीआर",
        mtbf: "एमटीबीएफ",
        totalRunHours: "कुल चलने का समय",
        RunHoursForCurrentMonth: "चालू माह के लिए घंटे चलाएं",
        runHours: "रन आवर्स",
        strengthAndConsumption: "ताकत और खपत",
        servicing: "सर्विसिंग",
        other: "अन्य",
        pumpSwitchOff: "पंप बंद है",
        warranty: "वारंटी",
        complaintRaised: "शिकायत उठाई",
        pumps: "पंप",
        systemType: "प्रणाली प्रकार",
        pumpDetails: "पंप तपशील",
        systemDetails: "प्रणाली तपशील",
        siteDetails: "साइट तपशील",
        alerts: "अलर्ट",
        causeMetricsConditions: "कारण मेट्रिक्स स्थितियां",
        alarm: "चेतावनी",
        customers: "ग्राहकों",
        customer: "ग्राहक",
        selectCustomer: "ग्राहक चुनें",
        upcomingMaintenance: "आगामी रखरखाव",
        alarms: "अलार्म",
        replace: "बदलें",
        by: "द्वारा",
        dueForReplacementBy: "द्वारा प्रतिस्थापन के कारण",
        serviceParameters: "सेवा पैरामीटर",
        till: "तक",
        expiredOn: "समाप्ति तिथि",
        triggerValue: "ट्रिगर मूल्य",
        runCounter: "दौड़ की गणना",
        on: "चालू",
        off: "बंद",
        alertAlarm: "अलर्ट और अलार्म",
        remote: "रिमोट",
        capitalizeOn: "चालू",
        capitalizeOff: "बंद",
        all: "सब",
        home: "मुख",
        complaints: "शिकायत",
        mySite: "मेरी साइट",
        member: "सदस्य",
        subscription: "सदस्यता",
        help: "मदद",
        subscriptionExpiry: "सदस्यता समाप्ति",
        more: "ज्यादा",
        tag: "टैग",
        type: "प्रकार",
        serialNumber: "क्रमिक संख्या",
        signal: "सिग्नल",
        energy: "ऊर्जा",
        pumpType: "पंप प्रकार",
        pumpNumber: "पंप नंबर",
        oaNumber: "ओए नंबर",
        flow: "बहे",
        totalHead: "टोटल हेड",
        totalHeadWithUnit: "टोटल हेड (एम)",
        driverRating: "ड्राइवर रेटिंग",
        nonSensorKey: "नॉन-सेंसर की",
        discharge: "डिस्चार्ज",
        pumpInputPower: "पंप इनपुट पावर",
        pumpInputPowerWithUnit: "पंप इनपुट पावर (किलोवाट)",
        impellerDiameter: "इम्पेलर व्यास",
        matCode: "मेट कोड",
        size: "आकार",
        speed: "गति",
        suctionDeliveryPipeSize: "सक्शन / डिलिवरी पाइप का आकार",
        suctionDeliveryPipeSizeWithUnit: "सक्शन / डिलिवरी पाइप का आकार (मिमी)",
        specificGravity: "विशिष्ट गुरुत्व",
        flowEstimationFactor: "फ्लो एस्टीमेशन फैक्टर",
        manufacturingDate: "विनिर्माण तिथि",
        invoiceNumber: "चालान संख्या",
        invoiceDate: "चालान तिथि",
        lastServiceOn: "अंतिम सेवा चालू",
        nextServiceOn: "अगली सेवा चालू",
        subscriptionExpired: "सदस्यता तक मान्य है",
        subscriptionDueOn: "सदस्यता तक मान्य है",
        subscriptionDueDate: "सदस्यता देय तिथि",
        modelNumber: "मॉडल नंबर",
        model: "मॉडल",
        rating: "ग्राहक द्वारा रेटिंग",
        make: "बनाओ",
        mcNumber: "म/सी नंबर",
        frame: "फ़्रेम",
        frameSizeOrMounting: "फ्रेम आकार / बढ़ते",
        kWHP: "के डब्ल्यू (एच पी)",
        rpm: "आरपीएम",
        volt: "वोल्ट",
        voltage: "वोल्टेज",
        energyRate: "ऊर्जा दर",
        voltageWithUnit: "वोल्टेज (वी)",
        current: "धारा",
        currentWithUnit: "धारा (ए)",
        frequency: "फ़्रीक्वेंसी",
        frequencyWithUnit: "फ़्रीक्वेंसी (हर्ट्ज)",
        inGraceProtection: "अनुग्रह संरक्षण में",
        duty: "कर्तव्य",
        powerFactor: "पावर फैक्टर",
        efficiency: "दक्षता",
        amp: "एएमपी",
        variableParameter: "चर पैरामीटर",
        digitalParameter: "डिजिटल पैरामीटर",
        ratedFrequency: "रेटेड फ्रीक्वेंसी",
        engineNumber: "इंजन नंबर",
        engineModel: "इंजन मॉडल",
        governorType: "गवर्नर टाइप",
        seeMore: "और देखें",
        seeLess: "कम देखें",
        application: "एप्लीकेशन",
        liquidMedia: "तरल/मीडिया",
        installationDate: "पंप इंस्टॉलेशन डेट",
        kirlosmartInstallationDate: "किर्लोस्मार्ट इंस्टॉलेशन डेट",
        requestQuote: "विनंती कोट",
        resolve: "निराकरण",
        markAsResolve: "संकल्प के रूप में चिह्नित करें",
        noAlertsMessage:
          "कोई अलर्ट नहीं, आपका पंप ठीक काम कर रहा है! बैठो और आराम करो।",
        noMaintenancesMessage: "कोई आगामी रखरखाव अलार्म नहीं! बैठो और आराम करो",
        dials: "डायल्स",
        unableToLoadData: "डेटा लोड करने में असमर्थ",
        power: "पावर",
        powerWithUnit: "पावर (किलोवाट)",
        powerWithUnitHp: "पावर (एचपी)",
        switchPumpOff: "पंप बंद करें?",
        takeControlOfThisFunctionality: "इस कार्यक्षमता पर नियंत्रण रखें",
        togglePumpMessage:
          'यदि आप "स्विच ऑफ" का विकल्प चुनते हैं, तो पंप को चालू करने का नियंत्रण केवल आपके पास होगा; और किसी अन्य उपयोगकर्ता के पास यह नियंत्रण नहीं होगा।',
        reason: "कारण",
        switchOff: "स्विच ऑफ",
        hello: "नमस्ते",
        searchBNameModelTagCustomerSite:
          "पंप नाम, मॉडल, टैग, ग्राहक, साइट द्वारा खोजें",
        welcomeToKirlosmart: "किर्लोस्मार्ट में आपका स्वागत है",
        overview: "अवलोकन",
        seeAll: "सभी देखें",
        healthyRange: "स्वस्थ रेंज",
        Digitalhealthy: "स्वस्थ",
        calibration: "अंशांकन",
        to: "से",
        viewOnMap: "नक्शा पर देखें",
        healthy: "स्वस्थ",
        alarming: "अलार्मिंग",
        tripping: "ट्रिपिंग",
        parameters: "मापदंडों",
        year: "वर्ष",
        generateCustomReports: "कस्टम रिपोर्ट जनरेट करें",
        report: "रिपोर्ट",
        reports: "रिपोर्ट",
        yourCurrentLocation: "आपका वर्तमान स्थान",
        cantLoadYourMapCheckYourInternetConnection:
          "नक्शा लोड करने में असमर्थ अपने इंटरनेट कनेक्शन की जांच करें",
        idleSince: "इस समय से निष्क्रिय",
        spares: "पुर्जों",
        trendGraphs: "रुझान रेखांकन",
        mimicImage: "मिमिक इमेज",
        lastReplaced: "पिछली बार बदला गया",
        nextProbableReplacement: "अगली संभावित प्रतिस्थापन",
        extendedTriggerValue: "विस्तारित ट्रिगर मान",
        standardTriggerValue: "मानक ट्रिगर मान",
        userSetValue: "उपयोगकर्ता सेट मान",
        EditUserSetValue: "उपयोगकर्ता सेट मान संपादित करें",
        EditSpareRunCounter: "स्पेयर रन काउंटर संपादित करें",
        spare: "स्पेयर",
        triggerValueForHighAlarms: "उच्च अलार्म के लिए ट्रिगर मूल्य",
        triggerValueForMediumAlarms: "मध्यम अलार्म के लिए ट्रिगर मूल्य",
        extendByHours: "विस्तार से (घंटे)",
        highAlarmsFrequency: "उच्च अलार्म आवृत्ति (hrs)",
        mediumAlarmsFrequency: "मध्यम अलार्म आवृत्ति (hrs)",
        hours: "घंटे",
        alarmingConditionRanges: "अलार्म कंडिशन रेंज",
        notificationDelay: "अधिसूचना विलंब",
        notificationFrequencyHours: "अधिसूचना आवृत्ति (घंटे)",
        notificationFrequency: "अधिसूचना आवृत्ति",
        trippingConditionRanges: "ट्रिपिंग कंडिशन रेंज्स",
        withMaterial: "सामग्री के साथ",
        withoutMaterial: "बिना सामग्री के",
        description: "विवरण",
        servicedOn: "पर सेवित",
        ifPumpWasServicedDuringResolution:
          "यदि संकल्प के दौरान पंप की सेवा की गई थी",
        complaintRaisedFor: "शिकायत की गई ",
        noSensorKeyData:
          "कोई पैरामीटर उपलब्ध नहीं है क्योंकि पंप में सेंसर कुंजी नहीं है",
        showPumps: "दिखाएँ {length} पंप",
        pumpSubscriptionExpiredMessage:
          "KirloSmart सदस्यता समाप्त हो गई है। आगे देखना जारी रखने के लिए, कृपया अपने व्यवस्थापक से संपर्क करें",
        systemSubscriptionExpiredMessage:
          "KirloSmart सदस्यता समाप्त हो गई है। आगे देखना जारी रखने के लिए, कृपया अपने व्यवस्थापक से संपर्क करें",
        pumpExpireMessage:
          "अधिक विवरण उपलब्ध नहीं है क्योंकि पंप की समय सीमा समाप्त हो गया है",
        requestQuoteFor: "विनंती कोट के लिए",
        request: "अनुरोध",
        systemExpireMessage:
          "अधिक विवरण उपलब्ध नहीं है क्योंकि सिस्टम समाप्त हो गया है",
        nonSensorKeyPump: "डेटा उपलब्ध नहीं है क्योंकि पंप में सेंसर नहीं है",
        nonSensorKeySystem:
          "डेटा उपलब्ध नहीं है क्योंकि सिस्टम में सेंसर नहीं है",
        looksLikeThereAreNoPumpsSystem:
          "ऐसा लगता है कि कोई पंप / सिस्टम नहीं हैं",
        notActive: "असक्रिय",
        startFrom: "से शुरु करें",
        format: "रिपोर्ट प्रारूप",
        excel: "एक्सेल",
        pumpRunHours: "पम्प चलाने का समय",
        daily: "दैनिक",
        weekly: "साप्ताहिक",
        fortNight: "पखवाड़ा",
        monthly: "महीने के",
        reportsSchedule: "रिपोर्ट अनुसूची",
        getReports: "चयनित समय और समय अंतराल पर रिपोर्ट प्राप्त करें।",
        showAlert: "रिपोर्ट में जनरेट किए गए अलर्ट दिखाएं",
        showAlarm: "रिपोर्ट में उत्पन्न अलार्म दिखाएं",
        reportsParameters: "रिपोर्ट में पैरामीटर",
        emailMessage: "सन्देश भेज देना",
        save: "बचाना",
        selectParameters:
          "मापदंडों का चयन करें और उनके अनुक्रम को पुनर्व्यवस्थित करें जिन्हें रिपोर्ट में दिखाना है",
        resetToDefault: "वितथ पर ले जाएं",
        customReport: "रिवाज़ रिपोर्ट भेजें",
        sendNow: "अब भेजें",
        cancel: "रद्द करना",
        oopsNoDataFound: "ओह...कोई डेटा नहीं मिला.",
        sending: "भेजना...",
        saveReport: "रिपोर्ट सुरक्षित रखना",
        downloading: "डाउनलोड हो रहा है...",
        subscriptionExpiredOn: "सदस्यता समाप्त",
        requestQuoteOfSpare: "के पुर्जे",
        engineElectricalSystem: "विद्युत व्यवस्था",
        engineElectricalSystemWithUnit: "विद्युत व्यवस्था (वी डीसी)",
        engineFuel: "इंजन ईंधन",
        engineCoolantGrade: "शीतलक ग्रेड",
        engineCoolantCapacity: "शीतलक क्षमता",
        engineCoolantCapacityWithUnit: "शीतलक क्षमता (लीटर)",
        engineOilGrade: "ऑइल ग्रेड",
        engineOilCapacity: "ऑइल क्षमता",
        engineOilCapacityWithUnit: "ऑइल क्षमता (लीटर)",
        engineListing: "लिस्टिंग",
        gearMakeModel: "बनाओ",
        gearServiceRating: "सेवा रेटिंग",
        gearServiceFactor: "सर्विस फॅक्टर",
        gearRatio: "गियर रेशो",
        medium: 'मध्यम',
        large: 'बड़ा',
        small: 'छोटा',
        configureView: 'दृश्य कॉन्फ़िगर करें',
        cardView: 'कार्ड दृश्य',
        dialView: 'डायल दृश्य',
        defaultView: 'सहज दृश्य',
        cardSize: 'कार्ड का आकार',
        showTrend: 'रुझान दिखाएँ',
        editPumpTotalRunHours: 'पंप के कुल चलने के घंटे संपादित करें',

        muteNotifications: {
          done: "किया हुआ",
          muteNotificationDescription:
            "आपको चयनित अवधि के लिए एसएमएस, ईमेल और पुश सूचनाएं प्राप्त नहीं होंगी।",
          sevenDays: "7 दिन",
          day: "24 घंटे",
          fourHours: "4 घंटे",
          muteForPeriod: "अवधि के लिए म्यूट करें",
          muteForAlert: "अलर्ट के लिए म्यूट करें",
          muteForAlarm: "अलार्म के लिए म्यूट करें",
          muteNotification: "सूचनाएं म्यूट करें",
        },
        pumpList: {
          no: "नहीं",
          available: "उपलब्ध",
        },
        looksLikeThereAreNoPumps: "ऐसा लगता है कि वहाँ नहीं हैं ",
        TotalHead: "कुल सिर",
        FullLoadCurrent: "फुल लोड करंट (FLC)",
        RatedFlow: "मूल्यांकित प्रवाह",
        MotorKW: "मोटर किलोवाट",
        MotorSpeed: "मोटर गति",
        motorVoltage: "मोटर वोल्टेज",
        motorFrequency: "मोटर आवृत्ति",
        pumpSystem: "पंप/प्रणाली",
        customerAndSite: "ग्राहक साइट",
        status: "स्थिती",
        pumpAndSystem: "पंप और प्रणाली",
        warrantyExpired: "वारंटी समाप्त",
        site: "स्थल",
        sensorKey: "सेंसर कुंजी",
        mfgDate: "विनिर्माण तारीख",
        warrantyDate: "वारंटी तिथि",
        availablePumps: "उपलब्ध पंप",
        selectedPumps: "चयनित पंप",
        flowWithUnit: "प्रवाह (एम 3 / घंटा)",
        impellerDiameterWithUnit: "प्ररित करनेवाला व्यास (मिमी)",
        speedWithUnit: "गति (आरपीएम)",
        modelName: "मॉडल नाम",
        subscriptionExpiryDate: "सदस्यता समाप्ति तिथि",
        media: "मीडिया",
        pumpModelWith: "पंप मॉडल के साथ",
        motorType: "मोटर प्रकार",
        engineType: "इंजन प्रकार",
        frameSizeMounting: "फ़्रेम का आकार / बढ़ते",
        standardMTTR: "मानक एमटीटीआर",
        standardMTBF: "मानक एमटीबीएफ",
        servicingAfterRunHours: "चलने के घंटों के बाद सर्विसिंग (घंटे)",
        servicingAfterMonths: "महीनों के बाद सर्विसिंग (महीनों की संख्या)",
        cause: "वजह :",
      },
      pumpRemark: {
        publishRemark: {
          noLabel: "नहीं, रद्द करें",
          yesLabel: "हाँ, प्रकाशित करें",
        },
        addRemark: {
          system: "प्रणाली",
          remarkFor: "के लिए टिप्पणी",
          remark: "टिप्पणी",
          add: "जोड़ें",
        },
        listing: {
          title: "टिप्पणियों",
          published: "प्रकाशित",
          addedBy: "द्वारा जोड़ा:",
          publishedBy: "द्वारा प्रकाशित:",
          selected: "चुन लिया",
          addNewRemark: "नई टिप्पणी जोड़ें",
          cancel: "रद्द करना",
          publishSelected: "चयनित प्रकाशित करें",
          noRemark: "अभी तक कोई टिप्पणी नहीं जोड़ी गई",
        },
      },
      auth: {
        login: "लॉग इन",
        logout: "लॉगआउट",
        email: "ईमेल",
        password: "पासवर्ड",
        setPassword: "पासवर्ड सेट करें",
        resetPassword: "पासवर्ड रीसेट करें",
        confirmPassword: "पासवर्ड की पुष्टि करें",
        forgotPassword: "पासवर्ड भूल गए?",
        setYourPassword: "अपना पासवर्ड निर्धारित करें",
        language: "भाषा",
        continue: "जारी रखें",
        changePassword: "पासवर्ड बदलें",
        oldPassword: "पुराना पासवर्ड",
        newPassword: "नया पासवर्ड",
        confirmNewPassword: "नए पासवर्ड की पुष्टि करें",
        verification: "सत्यापन",
        changeEmail: "बदले ई - मेल",
      },
      kebabMenu: {
        remarks: "टिप्पणियों",
        viewRemedy: "उपाय देखें",
        raiseComplaint: "शिकायत उठाएं",
        resolve: "संकल्प",
        muteNotifications: "म्यूट नोटिफिकेशन",
        scheduleMaintenance: "समय-सारणी",
        parameters: "पैरामीटर",
        spares: "पुर्जों",
        EnergySaving: "ऊर्जा बचत",
        activityLog: "गतिविधि लॉग",
        reports: "रिपोर्ट",
        addTagOrEditTag: "टैग जोड़ें या संपादित करें",
        addTag: "टैग जोड़ें",
        editTag: "टैग संपादित करे",
        help: "मदद",
        moreOptions: "अधिक विकल्प",
        viewAndEdit: "देखें और संपादित करें",
        duplicate: "डुप्लिकेट",
        delete: "हटाना",
        inactivate: "निष्क्रिय",
        deactivate: "निष्क्रिय करें",
        suspended: "बर्खास्त कर दिया",
        resetRunCounter: "रीसेट रन काउंटर",
        editUserSetValue: "उपयोगकर्ता सेट मान संपादित करें",
        editSpareRunCounter: "स्पेयर रन काउंटर संपादित करें",
        extendTriggerValue: "ट्रिगर मान बढ़ाएँ",
        moveUp: "ऊपर ले जाएँ",
        moveDown: "नीचे ले जाएँ",
        moveToTop: "शीर्ष पर जाएं",
        moveToBottom: "अंत तक ले जाएँ",
        editPumpMaster: "पंप मास्टर संपादित करें",
      },
      parameter: {
        edit: "संपादित करें",
        save: "सहेजें",
        from: "से",
        to: "तक",
        notificationDelay: "अधिसूचना में देरी",
        notificationFrequency: "अधिसूचना आवृत्ति",
        muteNotifications: "म्यूट नोटिफिकेशन",
        hrs: "घंटे",
        days: "दिन",
        lowestAlarmingValue: "सबसे कम खतरनाक मूल्य",
        highestAlarmingValue: "उच्चतम खतरनाक मूल्य",
        range: "सीमा",
        raisedOn: "जारी किया गया",
        resolvedOn: "हल किया गया",
        singleValue: "एकल मूल्य",
        oneHour: "1 घंटा",
        oneDay: "24 घंटे",
        sevenDays: "7 दिन",
        oneMonth: "1 महीना",
        custom: "रिवाज",
        customParameterTrend: "रिवाज पैरामीटर रुझान",
        EnergySavingTrend: "ऊर्जा बचत रुझान",
        viewTrend: "रुझान देखें",
        outOfRange: "सीमा से बाहर",
        view: "राय",
        altizonKey: "अल्टिज़ोन कुंजी",
        cloudAttribute: "बादल विशेषता",
        cloudAttributeValid: "बादल विशेषता मान्य",
        this: "इस",
      },
      language: "भाषा",
      help: {
        help: "मदद",
        faq: "सामान्य प्रश्न",
        faqSearch: "सामान्य प्रश्न शोध",
        search: "शोध",
        noData: "कोई डेटा उपलब्ध नहीं है",
        loading: "परिणाम लोड हो रहे हैं...",
        seeLess: "कम देखें",
        seeMore: "और देखें",
        language: "भाषाएँ",
        installationGuide: "इंस्टालेशन गाइड",
        iomProductBrochure: "उत्पाद संबंधी विवरण पुस्तिका",
        troubleshooting: "समस्या निवारण",
        trouble: "मुसीबत",
        symptom: "लक्षण",
        cause: "वजह",
        remedy: "निदान",
        attachments: "संलग्नक",
        pumpInstallationProcess: "पंप की पूर्ण स्थापना प्रक्रिया प्राप्त करें",
        informationOfKBLProducts: "KBL उत्पादों के बारे में जानें",
        resolutionForProblem: "सबसे आम समस्याओं के लिए संकल्प",
        getAnswerToYourQuestion: "अपने प्रश्न के उत्तर प्राप्त करें",
        dontFindAnything: "यदि आपको वह नहीं मिल रहा है जिसकी आपको तलाश है",
        selectLanguageOfInstallationGuide: "इंस्टालेशन गाइड की भाषा चुनें",
        selectLanguageOfProductBrochure:
          "उत्पाद संबंधी विवरण पुस्तिका की भाषा चुनें",
        otherDocuments: "अन्य कागजात",
        otherUsefulDocumentsOfPump: "पंप के अन्य उपयोगी दस्तावेज",
        productBrochure: "उत्पाद संबंधी विवरण पुस्तिका",
        helloHowCanWeHelp: "नमस्ते, हम आपकी सहायता किस तरह से कर सकते है?",
        guides: "गाइड",
        kirloskarEndSuctionPumps: "किर्लोस्कर एंड सक्शन पंप",
        iomDocuments: "आईओएम दस्तावेज़",
        etc: "आदि",
        addNew: "नया जोड़ो",
      },
      action: {
        save: "बचा ले",
        next: "अगला",
        back: "वापस",
        yes: "हाँ",
        no: "नहीं",
        done: "किया",
        clearAll: "सभी साफ करें",
        addNew: "नया जोड़ो",
        active: "सक्रिय",
        status: "स्थिति",
        cancel: "रद्द करें",
        add: "जोड़ें",
        update: "अद्यतन",
        edit: "संपादित करें",
        duplicate: "डुप्लिकेट",
        addNewParameter: "नया पैरामीटर जोड़ें",
        editParameter: "पैरामीटर संपादित करें",
        addNewSpares: "नए पुर्जे जोड़ें",
        saveAsDraft: "ड्राफ्ट के रूप में सेव करें",
        previous: "पहले का",
        preview: "पूर्वावलोकन",
        uploadImages: "तश्वीरें अपलोड करो",
        browse: "ब्राउज़",
        others: "अन्य",
        remove: "निकालना",
        backToLogin: "लॉगिन पर वापस जाएं",
        sendResetLink: "रीसेट लिंक भेजें",
        VariableParameter: "चर पैरामीटर",
        DigitalParameter: "डिजिटल पैरामीटर"
      },
      admin: {
        VariableParameter: "चर पैरामीटर:",
        digitalParameter: "डिजिटल पैरामीटर",
        admin: "व्यवस्थापक",
        approve: "मंजूर",
        autoEmailReport: "ऑटो ईमेल रिपोर्ट",
        disableAlarmNotification: "अलार्म सूचनाएं अक्षम करें",
        disableAlertNotification: "अलर्ट सूचनाएं अक्षम करें",
        disableStatusUpdateNotification: "स्थितिअद्यतनअधिसूचना अक्षम करें",
        reject: "अस्वीकार",
        editFaq: "देखें और संपादित करें",
        serialNo: "सीरीयल नम्बर",
        sensorKey: "सेंसर कुंजी",
        motor: "मोटर",
        engine: "यन्त्र",
        kbl: "केबीएल",
        healthyValue: "स्वस्थ",
        alarmingValue: "ट्रिपिंग ",
        displayText: "डिस्प्लेटेक्स्ट",
        zero: "शून्य",
        one: "एक",
        nonKbl: "गैर-केबीएल",
        customerAndSites: "ग्राहक और साइटें",
        customerAndSitesDetails: "ग्राहक और साइट विवरण",
        customerSites: "ग्राहक साइटें",
        customerAdmin: "ग्राहक व्यवस्थापक",
        customer: "ग्राहक",
        customerAdminDetails: "ग्राहक व्यवस्थापक विवरण",
        site: "स्थल",
        select: "चुनना",
        selectCauses: "कारण चुनें",
        selectRemedy: "उपाय चुनें",
        addNewCauses: "नया कारण जोड़ें",
        lastActivity : "अंतिम क्रियाकलाप",
        online : "ऑनलाइन",
        offline : "ऑफलाइन",
        isMCurrOrDirunAltizonAttributePresent : "MCURR/DIRUN गहाळ",
        isMenrgAttributePresent : "MENRG गहाळ",
        pumpId : "पंप आईडी",
        thingTemplateName : "सेंसर खाका",
        lastRefreshedTime : "अंतिम ताज़ा समय",
        ruleNotificationEvents : "नियम अधिसूचना घटनाएँ",
        dignostics : "निदान",
        data : "डेटा",
        alerts : "अलर्ट्स",
        edit : "संपादित करें",
        alertsCenter : "अलर्ट केंद्र",
        auditTrail : "लेखापरीक्षा",
        addNewRemedy: "नया उपाय जोड़ें",
        autoRefreshInterval: "ऑटो-रीफ्रेश अंतराल (मिनट)",
        zonalCoordinator: "आंचलिक समन्वयक",
        serviceEngineer: "सेवा अभियंता",
        kblServiceEngineer: "केबीएल सेवा अभियंता",
        switchRoles: "भूमिकाएं बदलो",
        noOfPumps: "पंपों की संख्या",
        timezone: "टाइमझोन",
        address: "पता",
        updatedOn: "को अपडेट किया",
        updatedBy: "द्वारा अपडेट",
        clear: "स्पष्ट",
        validOption: "मान्य विकल्प",
        inValidOption: "अमान्य विकल्प",
        userName: "उपयोगकर्ता नाम",
        role: "भूमिका",
        roles: "भूमिकाएँ",
        raisedOn: "जारी किया गया",
        resolvedOn: "हल किया गया",
        mobileNumber: "मोबाइल नंबर",
        phoneNumber: "फ़ोन नंबर",
        alternatePhoneNumber: "दूसरा फ़ोन नंबर",
        createdOn: "पर बनाया",
        uploadedBy: "द्वारा अपडेट",
        addUser: "उपयोगकर्ता जोड़ें",
        addRoles: "भूमिका जोड़ें",
        editRoles: "भूमिका संपादित करें",
        roleTitle: "भूमिका शीर्षक",
        accessRights: "पहुंच अधिकार",
        editUser: "यूजर को संपादित करो",
        duplicateUser: "डुप्लिकेट उपयोगकर्ता",
        rights: "अधिकार",
        assignDownload: "असाइन करें / डाउनलोड करें",
        name: "नाम",
        email: "ईमेल",
        users: "उपयोगकर्ताओं",
        personalDetails: "व्यक्तिगत विवरण",
        accessDetails: "एक्सेस विवरण",
        accessControl: "अभिगम नियंत्रण",
        suspendedUsers: "निलंबित उपयोगकर्ता",
        lockedUsers: "लॉक केलेला उपयोगकर्ता",
        suspendedOn: "पर निलंबित",
        suspendedBy: "द्वारा निलंबित",
        allowSiteAdminToConfigurePumpParameters:
          "साइट व्यवस्थापक को पंप पैरामीटर कॉन्फ़िगर करने दें",
        allowSiteAdminToResetAndChangeSpareCounters:
          "साइट व्यवस्थापक को अतिरिक्त काउंटरों को रीसेट करने और बदलने की अनुमति दें",
        country: "देश",
        zone: "क्षेत्र",
        allZone: "सभी क्षेत्र",
        east: "पूर्व",
        west: "पश्चिम",
        south: "दक्षिण",
        north: "उत्तर",
        central: "केंद्रीय",
        marketingContent: "विपणन सामग्री",
        healthCheck: "स्वास्थ्य जांच",
        marketingContentPreview: "मार्केटिंग सामग्री पूर्वावलोकन",
        regionalOffice: "क्षेत्रीय कार्यालय",
        pumpMasters: "पंप मास्टर्स",
        systemMasters: "प्रणाली मास्टर्स",
        pumpsAndSystems: "पंप और प्रणाली",
        masters: "मास्टर्स",
        masterName: "मास्टर नाम",
        category: "श्रेणी",
        systemType: "सिस्टम प्रकार",
        selectCategory: "श्रेणी का चयन करें",
        type: "प्रकार",
        application: "आवेदन",
        location: "स्थान",
        selectParametersToAddInTheMimicImage:
          "मिमिक इमेज में जोड़ने के लिए पैरामीटर चुनें",
        parameter: "पैरामीटर",
        pumpModel: "पंप मॉडल",
        healthyRange: "स्वस्थ रेंज",
        alarmingRange: "खतरनाक रेंज",
        invalidSensorKey : "अवैध सेंसर कुंजी",
        lastAlert : "शेवटचे अलर्ट",
        off: "पंप बंद आहे",
        on: "पंप चालू आहे",
        validValue: "(वैध मूल्य)",
        todayRunHour : "आज का चालू समय",
        trippingRange: "ट्रिपिंग रेंज",
        setValue: "मूल्य ते करना",
        addNewPumpMaster: "नया पंप मास्टर जोड़ें",
        addNewSystemMaster: "नया प्रणाली मास्टर जोड़ें",
        editPumpMaster: "पंप मास्टर संपादित करें",
        pumpMasterName: "पंप मास्टर का नाम",
        systemMasterName: "प्रणाली मास्टर नाम",
        systemDetails: "प्रणाली विवरण",
        pumpDetails: "पंप विवरण",
        staticDetails: "स्थिर विवरण",
        motorEngineDetails: "मोटर / इंजन विवरण",
        parameters: "मापदंडों",
        shortDiscription: "विवरण",
        shortDescription: "विवरण",
        parameterThresholdConfiguration: "पैरामीटर थ्रेसहोल्ड कॉन्फ़िगरेशन",
        parameterAlertFrequencyConfiguration:
          "पैरामीटर अलर्ट फ़्रीक्वेंसी कॉन्फ़िगरेशन",
        SparesAlertFrequencyConfiguration:
          "स्पेयर अलर्ट फ़्रीक्वेंसी कॉन्फ़िगरेशन",
        pumpApplication: "पंप आवेदन",
        applicationCommonParameters: "आवेदन आम पैरामीटर",
        pump: "पंप",
        helpMaster: "मदद मास्टर",
        causeMatrix: "कारण मैट्रिक्स",
        troubleShootingDetails: "समस्या निवारण विवरण",
        spares: "पुर्जों",
        sparesTriggerResetValues: "स्पेयर ट्रिगर/रीसेट मान",
        spareName: "अतिरिक्त नाम",
        helpDocuments: "सहायता दस्तावेज",
        mimicImageParameters: "मिमिक इमेज पैरामीटर्स",
        mimicImageAndParameters: "मिमिक इमेज और पैरामीटर्स",
        notificationFrequency: "अधिसूचना आवृत्ति",
        highAlarmFrequencyHrs: "उच्च अलार्म आवृत्ति (घंटे)",
        mediumAlarmFrequencyHrs: "मध्यम अलार्म आवृत्ति (घंटे)",
        mocCode: "एमओसी कोड",
        standardTriggerValueForHighAlerts: "उच्च अलर्ट के लिए मानक ट्रिगर मान",
        standardTriggerValueForMediumAlerts:
          "मध्यम अलर्ट के लिए मानक ट्रिगर मान",
        standardTriggerValuesHrs: "मानक ट्रिगर मान (घंटे)",
        addNewSpare: "नया अतिरिक्त जोड़ें",
        forHighAlarm: "उच्च अलार्म के लिए",
        forMediumAlarm: "मध्यम अलार्म के लिए",
        addNewCause: "नया कारण जोड़ें",
        updateCause: "अद्यतन कारण",
        all: "सभी",
        pumpAndSystems: "पंप और प्रणाली",
        pumpAndSystemMasters: "पंप और प्रणाली मास्टर्स",
        troubleDelete: "क्या आप वाकई इस समस्या को हटाना चाहते हैं?",
        causeDelete: "क्या आप वाकई इस कारण को हटाना चाहते हैं?",
        remedyDelete: "क्या आप वाकई इस उपाय को हटाना चाहते हैं?",
        "Add New Cause": "नया कारण जोड़ें",
        "Add New Remedy": "नया उपाय जोड़ें",
        "Add New Trouble": "नई परेशानी जोड़ें",
        Cause: "कारण",
        Trouble: "मुसीबत",
        Add: "जोड़ें",
        language: {
          english: "English",
          hindi: "Hindi",
          russian: "Russian",
          french: "French",
          german: "German",
          spanish: "Spanish",
        },
        others: "अन्य",
        installationGuide: "इंस्टालेशन गाइड",
        productBrochure: "उत्पाद संबंधी विवरण पुस्तिका",
        iom: "आईओएम",
        parameterName: "मापदण्ड नाम",
        unit: "इकाई",
        mfmMultiFunctionMeter: "एमएफएम - मल्टी फंक्शन मीटर",
        vdfVariableFrequencyDrive: "VDF - चर आवृत्ति ड्राइव",
        calibration: "कैलिब्रेशन",
        from: "से",
        to: "प्रति",
        threshold: "सीमा",
        MUCRRThresholdValueForPumpONOFFStatus: "पंप चालू/बंद स्थिति के लिए MUCRR थ्रेशोल्ड मान",
        TrendGraphNotAvailable: "डिजिटल पैरामीटर के लिए रुझान ग्राफ़ उपलब्ध नहीं है",
        range: "श्रेणी",
        singleValue: "एकल मूल्य",
        healthyRangeKgCm2: "स्वस्थ रेंज (किलो / सेमी 2)",
        alarmingRangeKgCm2: "अलार्मिंग रेंज (किलो/सेमी2) 1 - 1.07 और 1.76 - 3",
        highestValue: "उच्चतम मूल्य",
        lowestValue: "न्यूनतम मूल्य",
        notificationDelay: "अधिसूचना देरी",
        trippingRangeKgCm2: "ट्रिपिंग रेंज (किलो/सेमी2) 0 - 0.9 और 3.1 - 4",
        addParameterInCauseMetricsOptional:
          "कारण मैट्रिक्स में पैरामीटर जोड़ें (वैकल्पिक)",
        selectParameter: "पैरामीटर चुनें",
        causeMetrics: "कारण मैट्रिक्स",
        metricsAndValidMetrics: "मैट्रिक्स - मान्य मैट्रिक्स",
        validMetrics: "मान्य मैट्रिक्स",
        altizonParameters: "अल्टिज़ोन पैरामीटर (न्यूनतम-उच्चतम)",
        kblParameters: "KBL पैरामीटर (न्यूनतम-उच्चतम)",
        outOfSyncParameters: " पैरामीटर सिंक से बाहर हैं",
        oneParameterIsOutOfSync: "1 पैरामीटर सिंक से बाहर है",
        noParametersAreOutOfSync: "कोई भी पैरामीटर सिंक से बाहर नहीं है",
        serialNumber: "क्रमिक संख्या :",
        thingKey: "सेंसर की :",
        customerAndSite : "ग्राहक और साइटें",
        currentValue : "वर्तमान मूल्य",
        loadingMessage : "कृपया प्रतीक्षा करें, इसमें कुछ मिनट लग सकते हैं",
        upperAlarming: "ऊपरी खतरनाक",
        lowerAlarming: "लोअर अलार्मिंग",
        true: "सत्य",
        false: "असत्य",
        causeEffectMatrix: "कारण प्रभाव मैट्रिक्स",
        metrics: "मेट्रिक्स",
        valid: "वैध",
        parametersRange: "(उच्च-निम्न)",
        condition: "स्थिति",
        mtrFrequency: "मीटर आवृत्ति",
        mtrVolt: "माउंट वोल्ट",
        mtrCurr: "माउंट कुर",
        mtrPower: "माउंट पावर",
        mtrPowerFactor: "मोटर पावर फैक्टर",
        dischargePressure: "स्राव दाब",
        suctionPressure: "चूषण दबाव",
        flow: "प्रवाह",
        mtrDEBearingTemp: "माउंट डीई असर तापमान",
        mtrNDEBearingTemp: "माउंट एनडीई असर तापमान",
        mtrWindingTemp: "माउंट वाइंडिंग टेम्प",
        pmpDEBearingTemp: "पीपीपी डीई असर तापमान",
        pmpNDEBearingTemp: "पीपीपी एनडीई असर अस्थायी",
        mtrDEBearingVibr: "माउंट डीई बियरिंग वाइब्रू",
        mtrNDEBearingVibr: "माउंट एनडीई असर कंपन",
        pmpDEBearingVibr: "पीपीपी डीई असर कंपन",
        pmpNDEBearingVibr: "पीपीपी एनडीई असर कंपन",
        lower: "कम",
        upper: "अपर",
        probableCause: "संभावित कारण",
        notification: "अधिसूचना",
        addNewFaq: "नए सामान्य प्रश्न जोड़ें",
        selectOrCreateNewFaqCategory: "नई प्रश्न श्रेणी चुनें या बनाएं",
        question: "प्रश्न",
        answer: "उत्तर",
        troubles: "मुसीबतों",
        causes: "कारण",
        trouble: "मुसीबत",
        cause: "वजह",
        remedy: "निदान",
        linkForYes: "हाँ के लिए लिंक",
        linkForNo: "नो के लिए लिंक",
        selectCause: "कारण चुनें",
        remedyForAboveCause: "उपरोक्त कारण के लिए उपाय",
        attachments: "संलग्नक",
        addNewTroubleshootingGuide: "नई समस्या निवारण मार्गदर्शिका जोड़ें",
        selectOrCreateTrouble: "चुनें या समस्या पैदा करें",
        value: "मूल्य",
        atLeastOneCategoryShouldBeSelected:
          "कम से कम एक श्रेणी का चयन किया जाना चाहिए",
        userAndRoles: "उपयोगकर्ता और भूमिकाएँ",
        logo: "ग्राहक लोगो (वैकल्पिक)",
        cancel: "रद्द करें",
        add: "जोड़ें",
        addNew: "नया जोड़ो",
        remark: "पंप / सिस्टम टिप्पणी",
        reportCustomizationScheduler: "रिपोर्ट अनुकूलन शेड्यूलर",
      },
      adminMenu: {
        userManagement: "उपयोगकर्ता प्रबंधन",
        customerManagement: "ग्राहक प्रबंधन",
        settingAndConfiguration: "सेटिंग्स और विन्यास",
        customerAndSites: "ग्राहक और साइटें",
        causeEffectMatrix: "कारण प्रभाव मैट्रिक्स",
      },
      complaint: {
        complaints: "शिकायत",
      },
      members: {
        members: "सदस्य",
      },
      mySites: {
        mySites: "माय साइट्स",
        members: "सदस्य",
        siteDetails: "साइट विवरण",
        inviteMember: "सदस्य को आमंत्रित करें",
        access: "अभिगम",
        approvalPending: "स्वीकृति लंबित",
        sendInvite: "आमंत्रित करें",
        admin: "व्यवस्थापक",
        viewOnly: "केवल देखें",
        active: "सक्रिय",
        inactive: "निष्क्रिय",
        addMobileNo: "कृपया देश कोड के साथ मोबाइल नंबर जोड़ें",
      },
      subscriptions: {
        subscriptions: "सदस्यता",
      },
      sortFactorList: {
        numberOfAlerts: "अलर्ट की संख्या",
        numberOfPumps: "पंपों की संख्या",
        alphabetically: "वर्णक्रम",
      },
      activityLog: {
        title: "गतिविधि लॉग",
        description: "अलर्ट, पुर्जों, कार्यों, आदि का लॉग",
        noLogs: "अभी तक कुछ नहीं हुआ",
        tabs: {
          all: "सभी",
          alerts: "अलर्ट",
          alarm: "एलार्म",
          pump: "पंप",
          notification: "सूचनाएं",
        },
      },
    },
    MESSAGES: {
      oopsNoDataFound: "ओह...कोई डेटा नहीं मिला.",
      noCustomersAndSitesAdded: "अभी तक कोई ग्राहक और साइट नहीं जोड़ी गई",
      noUserSuspended: "किसी भी उपयोगकर्ता को अभी तक निलंबित नहीं किया गया है",
      noUserLocked: "अभी तक किसी भी उपयोगकर्ता को लॉक नहीं किया गया है",
      noImageAdded: "अभी तक कोई चित्र नहीं जोड़ा गया",
      noSpareDemand: "इस अवधि के लिए कोई अतिरिक्त मांग नहीं है",
      noCauseCondition: "इस अवधि के लिए कोई कारण स्थिति का पता नहीं चला है",
      noAlertsGeneratedForSite: "साइट के लिए कोई अलर्ट उत्पन्न नहीं हुआ",
      noFiltersAvailable: "कोई फ़िल्टर उपलब्ध नहीं",
      noDocumentsAdded: "कोई दस्तावेज़ नहीं जोड़ा गया.",
      noParametersAvailable: "कोई पैरामीटर उपलब्ध नहीं है",
      noReportsGenerated: "अभी तक कोई रिपोर्ट जनरेट नहीं हुई है।",
      noSparesAvailable: "कोई स्पेयर उपलब्ध नहीं है",
      noMimicAvailable: "कोई मिमिक इमेज उपलब्ध नहीं है.",
      noSitesAssigned: "आपको अभी तक कोई साइट असाइन नहीं की गई है",
      noRemarksAdded: "अभी तक कोई टिप्पणी नहीं जोड़ी गई",
      descriptionIsRequired: "विवरण आवश्यक है!",
      pumpRemark: {
        publishRemark: {
          title: "टिप्पणियां प्रकाशित करें",
          message:
            "एक बार चयनित टिप्पणियां प्रकाशित हो जाने के बाद, उन्हें अप्रकाशित या हटाया नहीं जा सकता है। क्या आप अभी भी प्रकाशित करना चाहते हैं?",
        },
        addRemark: {
          addNewRemark: "नई टिप्पणी जोड़ें",
        },
      },
      auth: {
        required: "आवश्यक क्षेत्र",
        emailIsRequired: "ईमेल आवश्यक है",
        enterValidEmail: "कृपया एक मान्य ईमेल पता दर्ज करें",
        passwordIsRequired: "पासवर्ड आवश्यक है",
        confirmPasswordIsRequired: "पासवर्ड की पुष्टि आवश्यक है",
        standardPasswordRequired: "पासवर्ड मानक प्रारूप से मेल नहीं खाता",
        passwordMustContain:
          "पासवर्ड में न्यूनतम आठ वर्ण, कम से कम एक अपरकेस अक्षर, एक लोअरकेस अक्षर, एक संख्या और एक विशेष वर्ण होना चाहिए",
        passwordStrengthPoor: "पासवर्ड की शक्ति: खराब",
        passwordNotMatching: "पासवर्ड से मेल खाना चाहिए",
        termsAgree: "मैं किर्लोस्कर ब्रदर्स से सहमत हूं",
        privacyPolicy: "गोपनीयता नीति",
        termsOfUse: "उपयोग की शर्तें",
        tokenNotAvailable: "टोकन उपलब्ध नहीं है",
        invalidRange: "कृपया एक मान्य श्रेणी दर्ज करें",
        invalidValue: "कृपया एक उचित मूल्य प्रविष्ट करें",
        agreePrivacyPolicyAndTerms:
          "सहमत गोपनीयता नीति और उपयोग की शर्तें आवश्यक",
        setPasswordEmail:
          "दिए गए ईमेल पते पर सफलतापूर्वक भेजा गया लिंक रीसेट करें। कृपया अपना इनबॉक्स जांचें।",
        linkIsExpired: "क्षमा करें, लिंक समाप्त हो गया है",
        userIsDeactivated:
          "आप वर्तमान में निष्क्रिय हैं कृपया अपने व्यवस्थापक से संपर्क करें",
        emailIs: "ईमेल है",
        invalidUrl: "अवैध यूआरएल",
        emailLink: "आपको उपरोक्त ईमेल पते पर एक रीसेट लिंक प्राप्त हुआ होगा।",
        otpVerificationMessage:
          "कृपया भेजे गए वन टाइम पासवर्ड (ओटीपी) को दर्ज करें",
        or: "या",
        notReceiveOTP: "ओटीपी प्राप्त नहीं हुआ",
        containValidWord: 'मान में "VALID" होना चाहिए',
        notContainValidWord: 'मान में "VALID" नहीं होना चाहिए',
        alphanumericAndSpacesOnly:
          "केवल अक्षरांकीय और रिक्त स्थान की अनुमति है",
        invalid: "अमान्य",
        invalidUnit: "अमान्य इकाई",
        alphabetAndSpaces: "केवल अक्षर और रिक्त स्थान की अनुमति है",
        numbersOnly: "केवल संख्याओं की अनुमति है",
        validRunHoursFormat: "केवल HH:MM प्रारूप में संख्याओं की अनुमति है, जिसमें घंटे किसी भी सीमा में तथा मिनट 00 से 59 तक हो सकते हैं।",
        alphanumericSpacesParenthesisAndHypen:
          "केवल () और - विशेष वर्णों की अनुमति है",
          alphanumericSpacesParenthesisHypenDotAndComma:
          "केवल & , . () और - विशेष वर्णों की अनुमति है",
          alphanumericSpacesParenthesisCommaSlashAndHypen:
          "केवल () , / और - विशेष वर्णों की अनुमति है",
      },
      toaster: {
        error: "त्रुटि",
        success: "सफलता",
        information: "सूचना",
        warning: "चेतावनी",
      },
      help: {
        deleteFaq: "क्या आप वाकई इस सामान्य प्रश्न को हटाना चाहते हैं?",
      },
      role: {
        deleteRole: "क्या आप वाकई इस भूमिका को हटाना चाहते हैं?",
      },
      user: {
        deactivateUser:
          "क्या आप वाकई इस उपयोगकर्ता को निष्क्रिय करना चाहते हैं?",
        suspendUser: "क्या आप वाकई इस उपयोगकर्ता को निलंबित करना चाहते हैं?",
      },
      site: {
        deactivate: "क्या आप वाकई इस साइट को निष्क्रिय करना चाहते हैं?",
        enterValidLocation: "कृपया मान्य अक्षांश और देशांतर दर्ज करें",
      },
      Error: {
        pumpDeactivated: `हा पंप निष्क्रिय केला आहे, कृपया तुमच्या प्रशासकाशी संपर्क साधा`,
        L0001: "खाते अस्तित्वात नाही.",
        L0002: "गलत पासवर्ड",
        L0003: "उपयोगकर्ता निष्क्रिय है, कृपया व्यवस्थापक से संपर्क करें",
        L0004:
          "सदस्यता समाप्त हो गई थी, सदस्यता को नवीनीकृत करने के लिए कृपया केबीएल टीम से संपर्क करें",
        L0005:
          "लॉगिन नहीं कर सकते क्योंकि कोई पंप/सिस्टम असाइन नहीं किया गया है, कृपया केबीएल टीम से संपर्क करें",
        userAccountIsLocked:
          "5 असफल लॉगिन प्रयासों के कारण आपका खाता लॉक कर दिया गया है, 30 मिनट के बाद पुनः प्रयास करें या एप्लिकेशन में लॉगिन करने के लिए व्यवस्थापक से संपर्क करें",
        invalidOTP: "ओटीपी गलत है",
        expiredOTP: "ओटीपी समाप्त हो गया है",
        failedOTPSend:
          "ओटीपी पुनः भेजने में विफल. कृपया बाद में पुन: प्रयास करें।",
        resetPasswordForKBLUser:
          "कृपया केबीएल सक्रिय निर्देशिका से पासवर्ड रीसेट करें और नए पासवर्ड के साथ पुनः लॉगिन करें",
        kblLoginServerNotResponse:
          "ऐसा लगता है जैसे हम अभी आपका लॉगिन संसाधित करने में असमर्थ हैं। प्रमाणीकरण सर्वर वर्तमान में अनुपलब्ध है. कृपया सहायता के लिए व्यवस्थापक से संपर्क करें या बाद में पुनः लॉग इन करने का प्रयास करें। हम किसी भी असुविधा के लिए खेद परकट करते है।",
        enterCorrectOldPassword: "कृपया सही पुराना पासवर्ड दर्ज करें",
        validNumber: "कृपया दशमलव के बिना संख्या दर्ज करें",
        noDataFound: "डाटा प्राप्त नहीं हुआ",
        internetConnectivityHasBeenLost:
          "इंटरनेट कनेक्टिविटी खो गई है, कृपया इंटरनेट कनेक्शन की जांच करें और अपनी अंतिम क्रिया का पुनः प्रयास करें",
        emailNotRegistered: "खाते अस्तित्वात नाही.",
        incorrectPassword: "गलत पासवर्ड",
        incorrectCredentials:
          "लॉगिन अयशस्वी. कृपया तुमच्या क्रेडेन्शियलचे पुनरावलोकन करा आणि पुन्हा प्रयत्न करा.",
        spareNameIsRequired: "अतिरिक्त नाम आवश्यक है!",
        remarkIsRequired: "टिप्पणी आवश्यक है!",
        maxLengthExceedRemark: "अधिकतम वर्ण सीमा 250 है",
        maxLengthExceedSpare: "अधिकतम वर्ण सीमा 700 है",
        fiveMBMaxSize: "अपलोड के लिए अनुमत अधिकतम फ़ाइल आकार: 5 एमबी",
        onlyUploadImage: "कृपया केवल छवि अपलोड करें",
        mocCodeIsRequired: "एमओसी कोड आवश्यक है!",
        highAlarmFrequencyIsRequired: "उच्च अलार्म आवृत्ति की आवश्यकता है!",
        mediumAlarmFrequencyIsRequired: "मध्यम अलार्म आवृत्ति आवश्यक है!",
        validContact: "कृपया मान्य मोबाइल/फोन नंबर दर्ज करें",
        validName: "कृपया मान्य नाम दर्ज करें",
        negativeValue: "मान 0 . से कम नहीं होना चाहिए",
        noDecimal: "मान दशमलव नहीं होना चाहिए",
        nonZero: "मान 0 नहीं होना चाहिए",
        oneDay: "मान 1 से 1440 . के भीतर होना चाहिए",
        fiveMinToOneDay: "मान 5 से 1440 . के भीतर होना चाहिए",
        required: "आवश्यक",
        noUserAccess:
          "इस कार्यक्षमता तक पहुंच प्राप्त करने के लिए कृपया अपने व्यवस्थापक से संपर्क करें।",
        addMobileWithCountry: "कृपया देश कोड के साथ मोबाइल नंबर जोड़ें",
        requiredName: "नाम आवश्यक है।",
        requiredCondition: "शर्त आवश्यक है",
        requiredProbableCause: "संभावित कारण आवश्यक है",
        requiredRemedy: "उपाय आवश्यक है",
        requiredNotification: "अधिसूचना आवश्यक है",
        lessThan500Characters: "कृपया 500 से कम वर्ण दर्ज करें",
        lessThan1000Characters: "कृपया 1000 से कम वर्ण दर्ज करें",
        atLeastOneParameter: "कृपया कम से कम एक पैरामीटर संयोजन का चयन करें",
        atLeastLowerUpper: "कृपया कम से कम निचला या ऊपरी चुनें",
        mimicImageResolution:
          "छवि समर्थित संकल्प की नहीं है। समर्थित छवि संकल्प क्षैतिज छवि के लिए 1280px X 720px और लंबवत छवि के लिए 1280px X 1440px हैं",
        fileIsNotValidImageFormat:
          "असमर्थित फ़ाइल स्वरूप। कृपया केवल पीएनजी, जेपीजी, जेपीईजी फ़ाइलें ही अपलोड करें।",
        fileIsNotValidPdfFormat:
          "असमर्थित फ़ाइल स्वरूप। कृपया केवल पीडीएफ फ़ाइलें ही अपलोड करें।",
          invalidFileFormat:
          "असमर्थित फ़ाइल स्वरूप। कृपया केवल पीडीएफ, जेपीजी, जेपीईजी और पीएनजी फ़ाइलें ही अपलोड करें।",
        filePixelSizeNotMatch:
          "छवि समर्थित संकल्प की नहीं है। समर्थित छवि संकल्प क्षैतिज छवि के लिए 1280px X 720px और लंबवत छवि के लिए 1280px X 1440px हैं",
        fileSizeExceededForPdf:
          "फ़ाइल बहुत बड़ी है। कृपया 5MB तक की फ़ाइलें अपलोड करें।",
        fileSizeExceededForImage:
          "छवि बहुत बड़ी है। कृपया 5MB तक की छवि अपलोड करें।",
        fileUploadLimit: "अधिकतम 10 फ़ाइलें अपलोड करने की सीमा पूरी हो गई",
        fileUploadLimit9: "अधिकतम 9 फ़ाइलें अपलोड करने की सीमा पूरी हो गई",
        fileUploadFailed: "फ़ाइल अपलोड विफल हुआ?",
        onlyAlphabetsAndSpaces: "केवल अक्षर और रिक्त स्थान की अनुमति है",
        alphanumericAndSpacesOnly:
          "केवल अक्षरांकीय और रिक्त स्थान की अनुमति है",
        alphanumericAndSpecialCharacters:
          'अनुमत विशेष वर्ण हैं .,/ " ; : - _ | #',
        alphanumericSpacesAndSlash:
          "केवल अल्फ़ान्यूमेरिक, रिक्त स्थान और स्लैश (/) की अनुमति है",
        causeMatrixRegex: "विशेष वर्णों की अनुमति है .,/()-+& और रिक्त स्थान",
      },
      adminPump: {
        model: "पंप मॉडल आईडी को हटा दें ",
        duplicate: "पंप मॉडल का डुप्लीकेट आईडी ",
        parameter: "पैरामीटर का हटा दिया गया आईडी ",
        deletePump: "क्या आप वाकई इस पंप मास्टर को हटाना चाहते हैं?",
        deleteParameter: "क्या आप वाकई इस पंप पैरामीटर को हटाना चाहते हैं?",
        deleteSpare: "क्या आप वाकई इस अतिरिक्त को हटाना चाहते हैं?",
        deleteMimicImage: "क्या आप वाकई इस नकली छवि को हटाना चाहते हैं?",
        deleteSystemMaster:
          "क्या आप सुनिश्चित हैं, आप $deleteItemName प्रणाली मास्टर को हटाना चाहते हैं?",
        deleteItem:
          "क्या आप वाकई $deleteItemName $deleteItemCategory को हटाना चाहते हैं?",
        removeItem:
          "क्या आप वाकई $deleteItemName $deleteItemCategory को हटाना चाहते हैं?",
        atLeastOnePumpShouldBeSelected:
          "कम से कम एक पंप का चयन किया जाना चाहिए",
        pleaseSelectCustomerAndSite: "कृपया ग्राहक और साइट का चयन करें",
        noMatchingPumpsAndSystems:
          "आवेदन में कोई मिलान पंप या प्रणाली उपलब्ध नहीं है",
        noMatchingPumpMasters:
          "आवेदन में कोई मैचिंग पंप मास्टर उपलब्ध नहीं है।",
        noMatchingSystemMasters:
          "एप्लिकेशन में कोई मैचिंग प्रणाली मास्टर उपलब्ध नहीं है।",
        mimicImageRatioMessage:
          "उचित दृश्यता के लिए, कृपया 1280px X 720px या 1280px X 1440px के आयामों में चित्र जोड़ें।",
      },
      language: {
        languageNotAvailable: "भाषा उपलब्ध नहीं है",
      },
      noDataAvailable: "कोई डेटा उपलब्ध नहीं है",
      pump: {
        fromDateShouldBeLessThanEndDate:
          "'तारीख' से 'अब तक' की तारीख से कम होनी चाहिए",
          fromDateToDateDifferenceCannotBeMoreThanOneYear:
          "प्रारंभ और समाप्ति के बीच का अंतर एक साल से अधिक नहीं हो सकता",
        selectDays: "अधिकतम रिपोर्ट अवधि 1 माह हो सकती है",
        maximum24HourPeriodAllowed:
          "अधिकतम 24 घंटे की अवधि की अनुमति है",
        notActive: "सक्रिय नहीं",
        notAvailable: "उपलब्ध नहीं",
        youHaveANewAlert: "आपके पास एक नया अलर्ट है",
        noCauseMatrix: "अद्याप कोणतेही कारण मॅट्रिक्स स्थिती आढळली नाही",
      },
      spare: {
        runCounterUpdatedSuccessfullyFor:
          "रन काउंटर सफलतापूर्वक अपडेट किया गया ",
        extendedTriggerValueUpdatedSuccessfullyFor:
          "विस्तारित ट्रिगर मान इसके लिए सफलतापूर्वक अपडेट किया गया ",
        userSetValueUpdatedSuccessfullyFor:
          "उपयोगकर्ता सेट मान को सफलतापूर्वक अपडेट किया गया ",
        runCounter: "दौड़ की गणना",
        validUserSetValue: "कृपया एक मान्य उपयोगकर्ता सेट मान दर्ज करें",
        validUserSetValue1: "6 अंकों की अधिकतम सीमा तक पहुँच गया है।",
        validUserSetValue2: "7 अंकों की अधिकतम सीमा तक पहुँच गया है।",
        ZeroUserSetValue: "यूज़र सेट वैल्यू शून्य नहीं हो सकती।",
        nullUserSetValue: "यूज़र सेट वैल्यू नल नहीं हो सकती।"

      },
      confirmationMessage: {
        muteNotification:
          "अब से आपको $timePeriod तक कोई एसएमएस, ईमेल और पुश नोटिफिकेशन नहीं मिलेगा। क्या आप अभी भी $parameterName के लिए सूचनाओं को म्यूट करना चाहते हैं?",
      },
      fileDownloaded: "फ़ाइल सफलतापूर्वक डाउनलोड हो गई.",
      invitationSent: "उपयोगकर्ता को आमंत्रण ईमेल भेज दिया गया है!",
      isOTPSent: "ओटीपी भेजा गया",
      reportSent: "रिपोर्ट सफलतापूर्वक भेजी गई।",
      QuoteSent: "उद्धरण सफलतापूर्वक अनुरोध किया गया है।",
      reportRequested:
        "अनुरोध प्रस्तुत किया गया है। कुछ ही मिनटों में रिपोर्ट भेज दी जाएगी।",
      reportSaveRequested:
        "अनुरोध प्रस्तुत किया गया है। रिपोर्ट कुछ ही मिनटों में डाउनलोड फोल्डर में सेव हो जाएगी।",
      parameter: {
        addHotspot: "मिमिक इमेज पर हॉटस्पॉट जोड़ें",
        addHotspotOptionSelectInfo:
          "इसे चुनकर, आप एक हॉटस्पॉट यानी मिमिक इमेज पर पैरामीटर का स्थान जोड़ सकते हैं",
        showParameterOnPumpDashboard: "प्रणाली के डैशबोर्ड पर दिखाएं",
        showParameterOnPumpDashboardInfo:
          "इसे चुनकर, आप प्रणाली के डैशबोर्ड पर इस पैरामीटर की निगरानी कर सकते हैं।",
        addParameterInCauseMatrixOptional:
          "कारण मैट्रिक्स में पैरामीटर जोड़ें (वैकल्पिक)",
        generateAlert: "अलर्ट उत्पन्न करें",
        generateAlertInfo:
          "इसे चुनने पर, पैरामीटर का ट्रिपिंग मान होने पर अलर्ट जेनरेट होगा।",
      },
      information: {
        detail1: "\"MCURR थ्रेशोल्ड\" मान केवल तभी लागू होता है जब पंप के लिए \"MCURR\" क्लाउड एट्रिब्यूट उपलब्ध हो। यदि MCURR का मान थ्रेशोल्ड मान से कम है, तो पंप को बंद माना जाएगा, अन्यथा इसे चालू माना जाएगा।",
        detail2: "यदि पंप के लिए \"MCURR\" क्लाउड एट्रिब्यूट उपलब्ध नहीं है, लेकिन \"DIRUN\" क्लाउड एट्रिब्यूट उपलब्ध है, तो पंप के चालू/बंद (चालू - 1, बंद - 0) के लिए \"DIRUN\" एट्रिब्यूट का मान उपयोग किया जाएगा। इस मामले में थ्रेशोल्ड मान लागू नहीं होगा।",
        detail3: "यदि पंप के लिए दोनों क्लाउड एट्रिब्यूट \"MCURR\" और \"DIRUN\" अनुपलब्ध हैं, तो पंप चालू/बंद की तर्क काम नहीं करेगी, इसलिए पंप के लिए इनमें से किसी एक एट्रिब्यूट का होना अनिवार्य है।"
      }
    },
    pumpMaster: {
      pumpMasters: "पंप मास्टर्स",
      addNew: "नया जोड़ें",
      masterName: "मास्टर नाम",
      category: "श्रेणी",
      updatedOn: "को अपडेट किया",
      updatedBy: "द्वारा अपडेट",
    },
    PLACEHOLDERS: {
      selectPump: "पंप",
      selectSite: "साइट का चयन करें",
      selectCustomer: "ग्राहक का चयन करें",
      selectCauseMatrix: "कारण मैट्रिक्स का चयन करें",
      selectMaster: "मास्टर का चयन करें",
      searchByCustomer: "ग्राहक द्वारा खोजें",
    },
  },
};
